import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  adminLoginRequest: ['payload'],
  adminLoginSuccess: ['adminInfo'],
  adminLoginFailure: ['error'],

  adminLogoutRequest: [],
  adminLogoutSuccess: [],
  adminLogoutFailure: ['error'],

  adminAddGoalsRequest: ['payload'],
  adminAddGoalsSuccess: ['addGoalsDetails'],
  adminAddGoalsFailure: ['error'],

  adminGetGoalsRequest: ['locationId'],
  adminGetGoalsSuccess: ['adminPreviousgoals'],
  adminGetGoalsFailure: ['error'],

  adminAddUnitsRequest: ['payload'],
  adminAddUnitsSuccess: ['addUnitsDetails'],
  adminAddUnitsFailure: ['error'],

  adminGetUnitsRequest: ['locationId'],
  adminGetUnitsSuccess: ['adminPreviousUnits'],
  adminGetUnitsFailure: ['error'],

  adminResetPasswordRequest: ['payload'],
  adminResetPasswordSuccess: ['isPasswordReset'],
  adminResetPasswordFailure: ['error'],

  adminGympassHistoryRequest: ['payload'],
  adminGympassHistorySuccess: ['gympassHistoryData'],
  adminGympassHistoryFailure: ['error'],
});

const adminActions = {
  Types,
  Creators,
};

export default adminActions;
